import React, { Component } from "react";
import "./loading.css";

class Loading extends Component {
  render() {
    var color = "black";
    if ("color" in this.props) color = this.props.color;
    return (
      <div className="sk-cube-grid">
        <div
          className="sk-cube sk-cube1"
          style={{ backgroundColor: color }}
        ></div>
        <div
          className="sk-cube sk-cube2"
          style={{ backgroundColor: color }}
        ></div>
        <div
          className="sk-cube sk-cube3"
          style={{ backgroundColor: color }}
        ></div>
        <div
          className="sk-cube sk-cube4"
          style={{ backgroundColor: color }}
        ></div>
        <div
          className="sk-cube sk-cube5"
          style={{ backgroundColor: color }}
        ></div>
        <div
          className="sk-cube sk-cube6"
          style={{ backgroundColor: color }}
        ></div>
        <div
          className="sk-cube sk-cube7"
          style={{ backgroundColor: color }}
        ></div>
        <div
          className="sk-cube sk-cube8"
          style={{ backgroundColor: color }}
        ></div>
        <div
          className="sk-cube sk-cube9"
          style={{ backgroundColor: color }}
        ></div>
      </div>
    );
  }
}

export default Loading;
